import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const LINKS = [
  { href: "#vessel", label: "The Vessel" },
  { href: "#gallery", label: "Gallery" },
  { href: "#trips", label: "Trips" },
  { href: "#amenities", label: "Amenities" },
  { href: "#crew", label: "Crew" },
  { href: "#location", label: "Location" },
  { href: "#contact", label: "Contact" },
];

export default function Nav() {
  const [solid, setSolid] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setSolid(window.scrollY > 60);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`aq-nav ${solid || open ? "is-solid" : "is-transparent"}`}
    >
      <div className="aq-container flex items-center justify-between py-4">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-3"
          onClick={() => setOpen(false)}
        >
          <img src="/brand/aquarius_logo_v2.png" alt="Aquarius Sport Fishing" className="h-10 w-auto" />
          <span className="hidden sm:flex flex-col leading-tight">
            <span className="aq-serif text-[18px]" style={{ color: "var(--aq-foam)" }}>
              Aquarius Sport Fishing
            </span>
            <span className="aq-overline" style={{ fontSize: 9 }}>
              Ocho Rios · Jamaica
            </span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-7 text-[13px] font-medium tracking-wide uppercase">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`} className="transition-colors">
              {l.label}
            </a>
          ))}
          <a href="#trips" className="aq-btn-primary" data-testid="nav-book-cta" style={{ padding: "10px 20px" }}>
            Book
          </a>
        </nav>

        <button
          className="md:hidden text-foam"
          aria-label="Toggle menu"
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          style={{ color: "var(--aq-foam)" }}
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t" style={{ borderColor: "rgba(201,162,74,0.2)", background: "rgba(11,30,63,0.98)" }}>
          <div className="aq-container py-4 flex flex-col gap-4">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-mobile-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                onClick={() => setOpen(false)}
                className="text-sm uppercase tracking-wider"
              >
                {l.label}
              </a>
            ))}
            <a href="#trips" className="aq-btn-primary self-start" onClick={() => setOpen(false)}>
              Book Your Charter
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
